import { render, staticRenderFns } from "./TreatmentRow.vue?vue&type=template&id=7643618d"
import script from "./TreatmentRow.vue?vue&type=script&lang=ts"
export * from "./TreatmentRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports